module.exports = __webpack_public_path__ + "img/1F6BA.1e8ab06b.svg";